import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertWarningBorderIcon extends BaseIcon {
  getChildren = () => [
    <g fill="#ffb72d">,
      <path d="M17 17.1H3c-1.1028 0-2-.8972-2-2v-.2098l.08432-.19212c.01452-.03307 1.47135-3.34472 3.18646-6.61278C7.53874 1.85835 8.95564 1 10 1c1.04436 0 2.46126.85835 5.72922 7.0853 1.71511 3.26806 3.17194 6.57971 3.18646 6.61278L19 14.89019V15.1c0 1.1028-.8972 2-2 2z"/>,
      <path d="M10 2C7.75 2 2 15.1 2 15.1c0 .552.448 1 1 1h14c.552 0 1-.448 1-1 0 0-5.75-13.1-8-13.1m0-2c1.60173 0 2.84015 1.46786 3.84033 2.90374.80438 1.15478 1.7378 2.74176 2.77435 4.71686 1.73125 3.2988 3.15683 6.53923 3.21667 6.67556L20 14.68039V15.1c0 1.65421-1.3458 3-3 3H3c-1.6542 0-3-1.34579-3-3v-.41961l.16865-.38423c.05984-.13633 1.48542-3.37676 3.21667-6.67556 1.03655-1.9751 1.96997-3.56208 2.77435-4.71686C7.15985 1.46786 8.39827 0 10 0z" fill="#fff"/>,
    </g>,
    <path d="M10 5.068c.552 0 1.5.448 1.5 1L11 10.1a1 1 0 01-2 0l-.5-4.032c0-.552.948-1 1.5-1zm.016 7.407a1.109 1.109 0 11-1.11 1.109 1.109 1.109 0 011.11-1.109z" fill="#fff"/>
    ]
  getViewBox = () => '0 0 20 18.1'
}
